<template>
  <v-container>
    <div class="center-container">
      <v-card
        tile
        elevation="0"
        class="pa-6"
      >
        <v-img :src="splashScreenImage" />

        <h1
          class="pt-5 text-center"
          :style="{ color: textColor }"
        >
          {{ $t('description.splashTitle') }}
        </h1>

        <h3 class="text-center font-weight-regular">
          {{ $t('description.splashMotto') }}
        </h3>
      </v-card>
    </div>
    <h5 class="font-weight-thin mt-2 text-center">
      {{ $t('description.splashText') }}
    </h5>
  </v-container>
</template>

<style>
.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85vh;
}
</style>

<script>
import { mapGetters } from 'vuex'
import SplashScreen from '@/agilis/components/SplashScreen/SplashScreen.vue'

export default {
  name: 'SplashScreenMobile',
  mixins: [SplashScreen],
  computed: {
    ...mapGetters({
      splashScreenImage: 'themeStore/getSplashScreenMobile'
    })
  }
}
</script>
